// Production environment configuration
const env = {
  // In production, API requests go through Firebase Functions
  API_URL: '',  // Empty base URL to avoid duplicate /api prefix
  FIREBASE_FUNCTIONS_URL: 'https://us-central1-fixmate-ai-mvp.cloudfunctions.net/api'
};

export default env;
